// File: Components/Structural/Sidebar/sidebarAppsConfig.js

import translations from "./translations.json";
import {
  FaApple,
  FaWifi,
  FaChair,
  FaFileAlt,
  FaEnvelope,
  FaCommentDots,
  FaLightbulb,
} from "react-icons/fa";

const preferredLanguage = localStorage.getItem("preferredLanguage") || "nl";
const t = translations[preferredLanguage] || translations["nl"];
const restaurantId = localStorage.getItem("username");

export const APP_IDS = {
  TODO: "todo",
  DATAHUB: "datahub",
  DOCUMENTS: "documents",
  REVIEWS: "reviews",
  TABLES: "tables",
  FOODCOST: "foodcost",
  INTERNETSNELHEID: "internetsnelheid",
  MATEZA_APP: "mateza-app",
  NOTITIES: "notities",
  AGENDA: "agenda",
  EXPORT: "export",
  MATEZA_EMAIL: "mateza-email",
  FEEDBACK: "feedback",
};

export const appsConfig = [
  {
    id: APP_IDS.TABLES,
    path: "/apps/tables",
    title: t.apps.tablePlan,
    icon: FaChair,
    url: "https://mateza-tables.vercel.app/jwt-auth/",
    domain: "mateza-tables.vercel.app",
    activeColor: "#56c0c4",
    docLink: "",
  },
  {
    id: APP_IDS.EXPORT,
    path: "/apps/export",
    title: t.apps.export,
    icon: FaFileAlt,
    url: "https://mateza-export.vercel.app/jwt-auth/",
    domain: "mateza-export.vercel.app",
    activeColor: "#56c0c4",
    docLink: "",
  },
  {
    id: APP_IDS.MATEZA_EMAIL,
    path: "/apps/email",
    title: t.apps.email,
    icon: FaEnvelope,
    url: "https://mateza-email.vercel.app/jwt-auth/",
    domain: "mateza-email.vercel.app",
    activeColor: "#56c0c4",
    docLink: "",
  },
  {
    id: APP_IDS.MATEZA_APP,
    path: "/apps/app",
    title: t.apps.matezaApp,
    icon: FaApple,
    url: "https://apps.apple.com/be/app/mateza-booking/id6740510109?l=nl",
    domain: null,
    activeColor: "#56c0c4",
    docLink: "",
    alwaysShow: true,
  },
];

export const toolsConfig = [
  {
    id: APP_IDS.FEEDBACK,
    path: "/hulpmiddelen/feedback",
    title: t.apps.feedback,
    icon: FaLightbulb,
    url: `https://feedback.happychef.cloud/`,
    domain: null,
    activeColor: "#66d6d8",
    docLink: "",
  },
];

export const shouldShowAppsSection = (installedApps) => {
  return (
    installedApps[APP_IDS.FOODCOST] ||
    installedApps[APP_IDS.TODO] ||
    installedApps[APP_IDS.DATAHUB] ||
    installedApps[APP_IDS.DOCUMENTS] ||
    installedApps[APP_IDS.REVIEWS] ||
    installedApps[APP_IDS.TABLES] ||
    installedApps[APP_IDS.NOTITIES] ||
    installedApps[APP_IDS.AGENDA] ||
    installedApps[APP_IDS.EXPORT] ||
    installedApps[APP_IDS.MATEZA_EMAIL]
  );
};
